<template>
  <div class="main-left-content-info" :style="{ left: left + 'px'}">
    <div v-for="(item, index) in deviceData" :key="index" class="item">
      <img :src="`/static/img/home/${item.icon}.png`" alt="">
      <div class="item-right">
        <p :style="{color: item.color}" :title="item.number">
          {{ item.number }}
        </p>
        <!-- <div class="title" :style="`borderColor: ${item.color}; boxShadow: 0 0 15px ${item.color} inset`">{{item.title}}</div> -->
        <div class="title">
          {{ item.title }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ContentInfo',
  props: {
    left: {
      type: Number,
      default: 20,
    },
    deviceData: {
      type: Array,
      default: () => { return [] },
    },
  },
  data () {
    return {
      list: [
        {
          icon: 'blue-icon',
          number: '0',
          title: '在线',
          color: '#045ABB',
        },
        {
          icon: 'yellow-icon',
          number: '0',
          title: '离线',
          color: '#c3c3c3',
        },
        {
          icon: 'red-icon',
          number: '0',
          title: '报警',
          color: '#F91B26',
        },
      ],
    }
  },
  created () {
  },
  mounted () {
    // this.initData()
  },
  methods: {
    initData () {
      this.$http.get('/api/device-info/count').then(res => {
        if (res.code === 'success') {
          res.data.list && res.data.list.forEach(({ name, value }) => {
            if (name === 'online') this.list[0].number = value
            if (name === 'offline') this.list[1].number = value
            if (name === 'day-warning') this.list[2].number = value
          })
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.main-left-content-info {
  padding: 20px 0px 20px 20px;
  position: absolute;
  top: 80px;
  left: 20px;
  z-index: 9;
  background: url(/static/img/home/parentBg.png) no-repeat;
  background-size: 100% 100%;
  transition: 0.5s;
  .item {
    display: inline-block;
    color: #fff;
    margin-right: 15px;
    // width: 150px;
    img {
      width: 50px;
      height: 50px;
      margin-right: 10px;
    }
    .item-right {
      display: inline-block;
      vertical-align: 6px;
      width: 90px;
      font-weight: bold;
      p {
        font-size: 22px;
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .title {
        font-size: 12px;
        // border: 1px solid #045ABB;
        height: 24px;
        line-height: 24px;
        text-align: center;
        border-radius: 20px;
        padding: 0px 5px;
        // box-shadow: 0 0 15px #045ABB inset;
        margin-top: 4px;
      }
    }
  }
}
</style>
